<script setup lang="ts">
/* Width is now controlled by Carousel/Base.vue via sizeSlides().
   The `width` prop is accepted but ignored for backwards compat. */
defineProps<{ width?: string }>();
</script>

<template>
  <div class="carousel-slide">
    <slot />
  </div>
</template>

<style lang="scss">
.carousel-slide {
  flex-shrink: 0;
  box-sizing: border-box;
  display: flex;
}
</style>
